import type { FaireProductEntity } from "../../entity_types/product";

export const p_vruynrey26: FaireProductEntity = {
  token: "p_vruynrey26",
  type: "product",
  name: "Mahj Wind Tile Hook Pillow - Ampersand",
  brandToken: "b_2cj1776q",
  brandName: "Peking Handicraft",
  imageUrl:
    "https://cdn.faire.com/fastly/4ee7196bbe78f12a89ed18f2a9cf4f544990d32c82f9c996d6378a01148bce3e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/87bca259b68eb0387cfeed786eb828219ee2eba564adc0070856b850e35478cc.jpeg",
    "https://cdn.faire.com/fastly/cac25d810a8625b1cb1c8d74cefddad4ef8f39a3952c773405dc4cc936cd5a81.jpeg",
    "https://cdn.faire.com/fastly/3b86caecdfe1050c6ec65da47d77b0385e3a064e07b17107982f55ed3add31a5.jpeg",
  ],
  priceDollars: 14,
  description:
    '• 100% wool hooked square accent pillow\n• 100% velvet backing\n• Includes polyester insert, zipper closure\n• 8X12" throw pillow\n• Minimum 3\n• Designed by Ampersand Design Studio',
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:44.371Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
